import { ToastPosition, toast } from "react-toastify";
import apiClient from "./apiClient";

export const registerUser = async (userData: {
  email: string;
  password: string;
  phone?: string;
  isAdmin?: boolean;
  street?: string;
  apartment?: string;
  zip?: string;
  city?: string;
  country?: string;
  name: string;
  dob: string;
  gender: string;
}) => {
  try {
    const response = await apiClient.post("/users/signup", userData);
    return response;
  } catch (error) {
    console.error("Error registering user", error);
    throw error;
  }
};

export const loginUser = async (credentials: { email: string; password: string }) => {
  try {
    const response = await apiClient.post("/users/login", credentials);
    return response;
  } catch (error) {
    throw error;
  }
};

export function handleToken(token: string): DecodedToken {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    const decoded = JSON.parse(jsonPayload);
    const userID = decoded?.userID || "";
    const isAdmin = decoded?.isAdmin || false;
    const expiry = decoded?.exp || 0;

    return { userID, isAdmin, expiry };
  } catch (error) {
    console.error("Invalid token", error);
    return { userID: "", isAdmin: false, expiry: 0 };
  }
}

export const notify = (
  message = "Something went wrong",
  position: ToastPosition = "top-right",
  autoClose = 1000,
  hideProgressBar = false,
  closeOnClick = true,
  pauseOnHover = true,
  draggable = true,
  progress = undefined,
  theme = "light"
) => {
  toast(message, {
    position,
    autoClose,
    hideProgressBar,
    closeOnClick,
    pauseOnHover,
    draggable,
    progress,
    theme,
  });
};

export const googleLoginUser = async (loginData: { email: string; token: string; name: string }) => {
  try {
    const response = await apiClient.post("/users/glogin", loginData);
    return response;
  } catch (error) {
    console.error("Error logging in user", error);
    throw error;
  }
};

export const changePassword = async (email: string, password: string, newPassword: string) => {
  try {
    const response = await apiClient.post("/users/changepassword", {
      email,
      password,
      newpassword: newPassword,
    });
    return response;
  } catch (error) {
    console.error("Error changing password", error);
    throw error;
  }
};

export const forgotPassword = async (email: string, newPassword: string) => {
  try {
    const response = await apiClient.post("/users/updatepassword", {
      email,
      newpassword: newPassword,
    });
    return response;
  } catch (error) {
    console.error("Error changing password", error);
    throw error;
  }
};
